module.exports = __webpack_public_path__ + "static/assets/21a46a49b55befa73d6b8352e2795d6f.svg";